import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { InventarioComponent } from "./inventario/inventario.component";
import {IngresoEquiposComponent} from "./ingreso-equipos/ingreso-equipos.component";
import { AsignacionEquiposComponent } from './asignacion-equipos/asignacion-equipos.component';
import { ReporteComponent } from './reporte/reporte.component';
import { ListaEquiposComponent } from './lista-equipos/lista-equipos.component';
import { CategoriaAgrupadoComponent } from './categoria-agrupado/categoria-agrupado.component';
import { AsignarEquiposFileComponent } from './asignar-equipos-file/asignar-equipos-file.component';
import { EgresoEquiposComponent } from './egreso-equipos/egreso-equipos.component';
import { AuthGuard } from '../services/guards/login.guard';
//const routes: Routes = [{ path: '', component: AlmacenEquiposComponent }];

@NgModule({
  imports: [RouterModule.forChild([
    {path:'',canActivate: [AuthGuard], component:InventarioComponent},
    {path:'ingresos',canActivate: [AuthGuard], component:IngresoEquiposComponent},
   /*  {path:'asignar', component:AsignacionEquiposComponent}, */
   {path:'egreso-equipos',canActivate: [AuthGuard], component:EgresoEquiposComponent},
   {path:'asignar/:fileId/:productId',canActivate: [AuthGuard], component:AsignarEquiposFileComponent},
    {path:'reporte',canActivate: [AuthGuard], component:ReporteComponent},
    {path:'lista-equipos',canActivate: [AuthGuard], component:ListaEquiposComponent},
    {path:'agrupado',canActivate: [AuthGuard], component:CategoriaAgrupadoComponent},
  ])],
  exports: [RouterModule]
})
export class AlmacenEquiposRoutingModule { }
